import { PartnerTheme } from './models';
import { PartnerConfigName } from '../api/models';

const primaryAccent = '#000';
const red = '#D52B1E';

const theme: PartnerTheme = {
  partnerName: PartnerConfigName.Verizon,
  colors: {
    primaryAccent,
    primaryAccentOnWhite: primaryAccent,
    primaryAccentFontColor: '#fff',

    gradient1Light: '#000',
    gradient1Dark: '#000',

    gradient2Light: '#000',
    gradient2Dark: '#000',

    error: '#ED7000',

    enrollmentStepBackground: '#fff',

    heroButtonBackground: '#fff',
    heroButtonFont: '#000',

    protectItBackground: primaryAccent,
    protectItFontColor: '#000',

    deviceIconAccent: red,

    calculatorBoxColor: primaryAccent,
    calculatorBoxFontColor: '#fff',
    calculatorInvestmentHighlight: '#000',
    calculatorInvestmentHighlightFontColor: '#fff',

    featureSection1: '#fff',
    featureSection2: '#000',
    finePrintSection: '#F9F9F9',

    featureSection1FontColor: '#1B1B1B',
    featureSection2FontColor: '#fff',

    signupConfirmationAccent: primaryAccent,
    signupNextButtonAccent: primaryAccent,

    linkColorLight: '#fff',
    linkColorDark: primaryAccent,

    faqAccent: primaryAccent,

    dashboardAccent: red,

    experiencesPrimaryButtonBackground: '#fff',
    experiencesPrimaryButtonTitle: '#000',

    experiencesBookingLauncherBoxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
    experiencesBookingLauncherBookLaterButtonTitle: '#fff',
  },
  fonts: {
    primary: 'VerizonNHGTX',
    isExperienceTextCapitalized: false,
  },
  styles: {
    buttonShadow: false,
    callToActionTextTransform: 'initial',
  },
  expert: {
    expertName: 'Tech Coach',
  },
};

export default theme;



// WEBPACK FOOTER //
// ./packages/smart-home-support/themes/TCH-WEB.ts